import api from '../../API';
import { IntegrationPreset } from '../../types';

export default {
  async findAll(): Promise<IntegrationPreset[]> {
    const response = await api.get('integration-presets');
    return response.data;
  },
};
